import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ShieldAlert } from 'lucide-react';

export default function NoAccess({ onLogout }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full text-center space-y-6 p-8">
        <div className="w-20 h-20 mx-auto bg-red-100 rounded-full flex items-center justify-center">
          <ShieldAlert className="w-10 h-10 text-red-600" />
        </div>
        
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-gray-900">
            Sin Permisos de Acceso
          </h1>
          <p className="text-gray-600">
            Tu cuenta no tiene permisos asignados para acceder a ningún módulo del sistema.
          </p>
          <p className="text-sm text-gray-500">
            Por favor, contacta al administrador para que te asigne los permisos necesarios.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <Button
            onClick={() => navigate('/login')}
            variant="outline"
            className="w-full"
          >
            Volver al Inicio
          </Button>
          <Button
            onClick={onLogout}
            variant="destructive"
            className="w-full"
          >
            Cerrar Sesión
          </Button>
        </div>
      </div>
    </div>
  );
}
